import type { ExtensionRegistry, ExtensionSlotName, SidebarExtension } from './contract';

/**
 * Process-wide registry of client-contributed UI. Populated once at startup by the repo's
 * client extension package (resolved through the `virtual:bw-client-extensions` module — see
 * the `clientExtensions()` plugin in `vite.config.ts`), and read by `<ExtensionSlot>` hosts.
 *
 * In a repo with no client extension package the registry simply stays empty and every slot
 * renders nothing.
 */
class Registry implements ExtensionRegistry {
	private readonly slots = new Map<ExtensionSlotName, SidebarExtension[]>();

	add(slot: ExtensionSlotName, extension: SidebarExtension): void {
		const list = this.slots.get(slot) ?? [];
		// Idempotent: tolerate a double `register()` (e.g. React StrictMode / HMR re-eval).
		if (list.some(e => e.key === extension.key)) return;
		list.push(extension);
		this.slots.set(slot, list);
	}

	get(slot: ExtensionSlotName): SidebarExtension[] {
		return this.slots.get(slot) ?? [];
	}
}

export const extensionRegistry: Registry = new Registry();
